// inputs state active/inactive funcs

import { updateAreaActiveDependsOnElementValue } from 'src/app/core/helpers/fields-utils'

/**
 * check input value and set active if it presents
 * else set inactive
 * @param arrayData list of divs/inputs
 */
export function changeInputVisibleStateAll(that, arrayData: NodeList) {
  Array.prototype.forEach.call(arrayData, (el) => {
    const inputField = el.querySelector('input')
    if (inputField) {
      const controlName = inputField.getAttribute('formcontrolname')
      if (!controlName) {
        return
      }
      const control = that.loanForm.get(controlName)
      const inputVal = control.value
      if (!inputVal) {
        return
      }
      // SKIP removing from DOB after errors
      if (that.ssn_dobErrors && controlName === 'dateOfBirth') {
        return
      }
      updateAreaActiveDependsOnElementValue(el, inputVal)
    }
  })
}

/**
 * manipulate targetElement classes & focus input / click select
 * @param targetElement div of other container
 * @param apply - is set active is neccessary
 */
export function inputSelectAriaCheckActiveState(targetElement: any, apply?: boolean): void {
  if (targetElement.classList.contains('input-area__inactive') || apply) {
    targetElement.classList.remove('input-area__inactive')
    targetElement.classList.add('input-area__active')

    const input = targetElement.querySelector('input')
    if (input) {
        input.focus()
      }
    const select = targetElement.querySelector('select')
    if (select) {
        select.click()
    }
  }
}

/**
 * developed for ssn input specially
 * manipulate targetElement classes & focus input
 * @param targetElement div of other container
 * @param apply - is set active is neccessary
 */
export function inputAriaCheckActiveStateSSN(targetElement: any, apply?: boolean): void
{
  if (targetElement.classList.contains('subnput-area__inactive') || apply) {
    targetElement.classList.remove('subnput-area__inactive')
    targetElement.classList.add('subnput-area__active')
    const input = targetElement.querySelector('input')
    if (input) {
        input.focus()
      }
  }
}
